import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from '../../utils/axios-instance';

export const fetchEmail2faVerified = createAsyncThunk(
    "email2faVerifiedSlice/fetchEmail2faVerified",
    async () => {
        try {
            const response = await axiosInstance( {
                method: "get",
                url: "/2fa-status"
            })

            return response.data.data
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    },
);
